// Code dependencies
import '../sass/app.scss'
import 'bootstrap'

import Vue from 'vue';
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

const moment = require('moment');
const axios = require('axios').default;
axios.defaults.headers.common['X-CSRFToken'] = csrftoken;


import {Tweet} from 'vue-tweet-embed'
import App from "./components/App";

import {mapActions} from 'vuex'

window.Vue = Vue;

// Global registrations
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueToast);
Vue.component('Tweet', Tweet);

import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)


async function wait(ms) {
      return new Promise(resolve => {
        setTimeout(resolve, ms);
      });
    }


const store = new Vuex.Store({
    state: {
        errorMessage: null,
        tweetSearchHistory: [],
        user: null,
        tweet: null,
        tweetUser: null,
        tweetUserAdditionalStats: null,
        fetchingUserAdditionalStats: false,
        veracityResponses: [],
        replies: null,
        replyHistogram: null,
        fetchingReplies: false,
        replySortOptions: {
            newest: "Newest first",
            oldest: "Oldest first",
            highConf: "Highest confidence",
            lowConf: "Lowest confidence"
        },
        replySort: "newest",
        replyShow: "all",
        replyAccountShow: "All",
        siteConfig: {
            showOtherUserVotes: null,
            showMachineVeracity: null,
            },
        },
    mutations: {
        updateErrorMessage(state, errorMsg) {
            state.errorMessage = errorMsg;
        },
        updateUser(state, user) {
            state.user = user;
        },
        updateSiteConfig(state, payload){
            state.siteConfig.showOtherUserVotes = payload.data.showOtherUserVotes;
            state.siteConfig.showMachineVeracity = payload.data.showMachineVeracity;
        },
        addTweetSearchHistory(state, tweetId) {
            state.tweetSearchHistory.push(tweetId);
        },
        updateTweet(state, payload) {
            state.tweet = payload.tweet;
            state.tweetUser = payload.tweetUser;
            state.tweetUserAdditionalStats = null;
            state.replies = null;
            state.veracityResponses = [];
        },
        updateTweetUserAdditionalStats(store, statsObject) {
            store.tweetUserAdditionalStats = statsObject;
        },
        isFetchingAdditionalStats(state, isFetching) {
            state.fetchingUserAdditionalStats = isFetching;
        },
        updateTweetVeracityResponses(state, payload) {
            state.veracityResponses = payload.veracityResponses;
        },
        updateReplies(state, payload) {
            state.replies = payload.replies;
            state.replyHistogram = payload.replyHistogram;
        },
        isFetchingReplies(state, isFetching) {
            state.fetchingReplies = isFetching;
        },
        updateRepliesShowOption(state, option) {
            state.replyShow = option;
        },
        updateRepliesAccountShowOption(state, option) {
            state.replyAccountShow = option;
        },
        updateRepliesSortOption(state, option) {
            state.replySort = option;
        },
        clearHistogram(state) {
            state.replyHistogram = null;
        },
        updateExternalLink(state, payload) {
            for(const propName in payload.exturlData){
                payload.stateExturl[propName] = payload.exturlData[propName];
            }

        }

    },
    getters: {

        replyShowStanceOptions(state) {

            let options = {all: "All"};

            if (state.replies) {
                for (const index in state.replies) {
                    const stanceText = state.replies[index].stance_text;
                    if (!(stanceText in options)) {
                        options[stanceText] = stanceText;
                    }
                }
            }

            return options;
        },
        /**
         * Gets the tweet thread i.e. tweets in which the author self replies
         * to their own tweet
         * @param state
         * @returns {[*]|null}
         */
        threadReply(state){
            if(!state.replies || state.replies.length < 1 || !state.tweetUser)
                return null;

            const selfReply = state.replies.find(reply =>  reply.user.id_str == state.tweetUser.id_str);

            if(selfReply){
                let threadArray = [selfReply];
                while(true){
                    const lastReply = threadArray[threadArray.length -1];
                    const subSelfReply = lastReply.replies ? lastReply.replies.find(reply =>  reply.user.id_str == state.tweetUser.id_str) : null;
                    if(subSelfReply){
                        threadArray.push(subSelfReply);
                    }
                    else{
                        break;
                    }
                }

                return threadArray;
            }

            return null;

        },
        /**
         * Get replies of the tweet, sorted by replySort and replyShow criteria
         * @param state
         * @returns {null|*}
         */
        sortedReplies(state) {
            if (state.replies) {

                const date_format = "DD-MM-YYYY HH:mm:ss";

                let sortedOutput = state.replies
                    .filter(reply => {
                        //Replies to self is tweet 'thread' instead
                        if(reply.user.id_str != state.tweetUser.id_str)
                        {
                            //Filter by stance
                            if (state.replyShow === "all") {
                                return true;
                            } else {
                                return state.replyShow === reply.stance_text;
                            }
                        }
                        else{
                            return false;
                        }


                    })
                    
                    .filter(reply => {
                        if (state.replyAccountShow === "unverified"){
                            return reply.user.verified === false;
                        } else if (state.replyAccountShow == "verified") {
                            return reply.user.verified === true;
                        } else {
                            return true;
                        }
                    })

                    .sort((reply1, reply2) => {
                        if (state.replySort === "newest") {
                            const date1 = moment(reply1.created_date, date_format);
                            const date2 = moment(reply2.created_date, date_format);
                            return date2.diff(date1);

                        } else if (state.replySort === "oldest") {
                            const date1 = moment(reply1.created_date, date_format);
                            const date2 = moment(reply2.created_date, date_format);
                            return date1.diff(date2);

                        } else if (state.replySort === "highConf") {
                            return 0;
                        } else {
                            //Lowest confidence first
                            return 0;
                        }
                    });

                return sortedOutput;
            } else {
                return null;
            }
        },
        /**
         * Get external url in the sorted tweet replies
         * @param state
         * @param getters
         * @returns {[]|*[]}
         */
        repliesExternalUrls(state, getters) {
            if (!getters.sortedReplies || getters.sortedReplies.length < 1)
                return [];

            let outputUrls = [];

            for (const i in getters.sortedReplies) {
                const reply = getters.sortedReplies[i];
                outputUrls = outputUrls.concat(reply.external_urls);
            }

            return outputUrls;
        },
        /**
         * Gets the external media urls in the tweet replies
         * @param state
         * @param getters
         * @returns {[]|*[]}
         */
        repliesMediaEntities(state, getters) {
            if (!getters.sortedReplies || getters.sortedReplies.length < 1)
                return [];

            let outputUrls = [];

            for (const i in getters.sortedReplies) {
                const reply = getters.sortedReplies[i];
                outputUrls = outputUrls.concat(reply.media_entities);
            }

            return outputUrls;

        }


    },
    actions: {
        displayErrorMessage({commit}, errorMsg) {
            Vue.$toast.open({
                message: errorMsg,
                type: "error",
                position: "top",
              })
        },
        displaySuccessMessage({commit}, msg) {
            Vue.$toast.open({
                message: msg,
                type: "success",
                position: "top",
              })
        },
        updateUser({commit}, user) {
            commit("updateUser", user);
        },
        updateSiteConfig({commit}) {

            axios
                .get("/vapi/site_config")
                .then(response => {

                    // console.log(response.data);
                    commit("updateSiteConfig", response);

                })
                .catch((error => {
                    console.log(error);
                }));

        },
        updateTweet({dispatch, commit, state}, payload) {

            commit('addTweetSearchHistory', payload.address);


            axios
                .get("/vapi/tweet/" + payload.address)
                .then(response => {
                    // console.log(response.data);
                    commit('updateTweet', {
                        tweet: response.data.tweet,
                        tweetUser: response.data.tweet_user,
                    });

                    dispatch("checkExternalLinks", state.tweet);

                    let payload = {tweetId: state.tweet.id_str};

                    //Then fetch the replies
                    dispatch("updateReplies", payload);

                    //And the veracity responses
                    dispatch("updateTweetVeracityResponse", payload);

                })
                .catch(error => {
                    console.log(error);
                });
        },
        async requestAdditionalUserData({dispatch, commit, state}) {
            if (state.tweetUser) {
                commit("isFetchingAdditionalStats", true);
                try{
                    while(true){
                        const response = await axios.get("/vapi/tweet_user_stats/" + state.tweetUser.id_str);
                        if (response.data.completed) {
                            commit("updateTweetUserAdditionalStats", response.data);
                            break;
                        }
                        await wait(4000);
                    }
                }catch (e) {
                    console.error(e);
                }
                commit("isFetchingAdditionalStats", false);
            }
        },
        /**
         *
         * @param commit
         * @param payload {{tweetId:String}}
         */
        updateTweetVeracityResponse({commit}, payload) {

            axios
                .get("/vapi/tweet_veracity_responses/" + payload.tweetId)
                .then(response => {

                    // console.log(response.data);
                    commit("updateTweetVeracityResponses", {veracityResponses: response.data.veracity_responses});

                })
                .catch((error => {
                    console.log(error);
                }));

        },
        /**
         *
         * @param commit
         * @param payload {{tweetId:String, veracity:Number, evidence:String}} Parameters to send to the API
         */
        async addVeracityVote({dispatch, commit, state}, payload) {

            if (!state.user || !state.user.isAuthenticated) {
                dispatch("displayErrorMessage", "Must be logged in to vote");
                return;
            }

            const params = {
                tweetid: payload.tweetId,
                veracity: payload.veracity,
                evidence: payload.evidence,
            };
            try{
                const response = await axios.post("/vapi/vote_veracity/", params);
                dispatch("updateTweetVeracityResponse", {tweetId: payload.tweetId});
                if (response.status == 200){
                    dispatch("displaySuccessMessage","Veracity feedback posted successfully")
                }
            }catch (e) {
                console.error(e);
                if (e.response.status == 400){
                    dispatch("displayErrorMessage",e.response.data.detail);
                }else{
                    dispatch("displayErrorMessage", "Already voted or must be logged in to vote");
                }
            }
        },
        async addStanceVote({dispatch, commit, state}, payload) {
            if (!state.user || !state.user.isAuthenticated) {
                dispatch("displayErrorMessage", "Must be logged in to vote");
                return;
            }

            const params = {
                tweetid: payload.tweetId,
                stance: payload.stance,
            };

            try{
                const response = await axios.post("/vapi/vote_stance/", params);
                dispatch("updateReplies", {tweetId: state.tweet.id_str});
                if (response.status == 200){
                    dispatch("displaySuccessMessage","Stance vote posted successfully")
                }
            }catch (e) {
                console.error(e);
                if (e.response.status == 400){
                    dispatch("displayErrorMessage",e.response.data.detail);
                }else{
                    dispatch("displayErrorMessage", "Already voted or must be logged in to vote");
                }
            }
        },
        async updateReplies({dispatch, commit}, payload) {

            commit("isFetchingReplies", true);
            try{
                while(true)
                {
                    const response = await axios.get("/vapi/tweet_replies/" + payload.tweetId);
                    if (response.data["completed"]) {
                        commit("updateReplies",
                            {
                                replies: response.data.replies,
                                replyHistogram: response.data.reply_histogram,
                            });
                        commit("isFetchingReplies", false);
                        break;
                    }
                    await wait(4000);
                }

            }catch (e) {
                console.log(e);
            }
            commit("isFetchingReplies", false);

        },
        updateRepliesShowOption({commit}, option) {
            commit('updateRepliesShowOption', option);
        },
        updateRepliesAccountShowOption({commit}, option) {
            commit('updateRepliesAccountShowOption', option);
        },
        updateRepliesSortOption({commit}, option) {
            commit('updateRepliesSortOption', option);
        },
        clearHistogram({commit}) {
            commit('clearHistogram');
        },
        async checkExternalLink({dispatch, commit}, exturl){
            try {
                while (true) {
                    let response = await axios.get(`/vapi/external_link_check/${exturl.id}`);
                    if (response.data.checked) {
                        commit("updateExternalLink", {
                            stateExturl: exturl,
                            exturlData: response.data.exturl
                        });
                        break;
                    }
                    await wait(3000);
                }

            } catch (e) {
                console.error(e);
                commit("updateExternalLink", {
                    stateExturl: exturl,
                    exturlData: {
                        credibility_text: "Could not fetch credibility score"
                    }
                });

            }
        },
        async checkExternalLinks({dispatch, commit, state}, tweet) {
            for (const i in tweet.external_urls) {
                const exturl = state.tweet.external_urls[i];
                if (!exturl.checked) {
                    dispatch("checkExternalLink", exturl);
                }
            }
        }

    }
});

const routes = [
    {path: "/tweet/:tweetId", component: App},
    {path: "*", component: App}
];

const router = new VueRouter({
    mode: 'history',
    routes: routes
});

const vm = new Vue({
    router,
    store,
    el: '#app',
    components: {
        App
    },
    methods: {
        ...mapActions(["updateUser", "updateSiteConfig"]),
    },
    beforeMount() {
        this.updateSiteConfig();
    },
    mounted() {
        //Adds user's details reactive
        if (user) {
            this.updateUser(user);
        }
    }


});
